export enum Environments {
  DEVELOP = "develop",
  STAGE = "stage",
  PRODUCTION = "production",
  LOCAL = "local",
  TEST = "test",
}
